import React, { Component }  from 'react';
import PropTypes from 'prop-types';
import {sampleContent}                  from '../../utils/sample-content';
import RecentList                       from './StorageHistory';

class SamplesControl extends Component {
    constructor(props){
        super(props);
        this.loadFromLocal = this.loadFromLocal.bind(this);
        this.removeFromLocal = this.removeFromLocal.bind(this);
        this.setTextFromSample = this.setTextFromSample.bind(this);
        this.process = this.process.bind(this);
        this.update = this.update.bind(this);
        this.addToList = this.addToList.bind(this);
        this.clearList = this.clearList.bind(this);

        this.state = {
            list: this.loadFromLocal(),
        }
    }

    loadFromLocal() {
        const recentDocs = localStorage.getItem('recentDocuments');

        if ((recentDocs === '') || (recentDocs === null))  {
            // if nothing is found in our history, set a default container
            localStorage.setItem('recentDocuments', JSON.stringify([]));
            return [];
        }

        return JSON.parse(recentDocs);
    };
    
    removeFromLocal(doc) {
        let recentDocs = JSON.parse(localStorage.getItem('recentDocuments'));
        let i;

        // Find the document to remove
        let index = -1;
        for (i = 0; i < recentDocs.length; i++) {
            if (recentDocs[i].text === doc.text) {
                index = i;
                break;
            }
        }

        // If we found it, remove from localstorage and update state
        if (index > -1) {
            recentDocs.splice(index, 1);
            localStorage.setItem('recentDocuments', JSON.stringify(recentDocs));

            this.setState({
                list: recentDocs
            })
        }       
    }

    setTextFromSample(sampleIndex) {
        var selectedSample = sampleContent[sampleIndex];
        if (selectedSample) {
            this.setState({text: selectedSample.content });
            if (this.props.onChange) {
                this.props.onChange(selectedSample.content);
            }
        }
    };

    process(docObj){
        this.update(docObj.text);
    };

    update(tag){
        this.setState({text: tag});
        if (this.props.onChange) {
            this.props.onChange(tag);
        }
    };
    
    addToList(item){

        var maxDocs = window._maxRecentDocs - 1;

        this.state.list.push(item);
        if (this.state.list.length > maxDocs) {
            this.state.list.shift();
        }
    };
    
    clearList(){
        this.setState({
            list: []
        });
    };

    render() {
    
        var sampleDocuments = [];
        var that = this;
    
        sampleContent.map(function(sampleText, index) {
            sampleDocuments.push(
                <p className="samplescontrol-document" key={index}>
                    <button className="link-button" onClick={that.setTextFromSample.bind(null, index)}>
                        <span className='fa fa-angle-double-left'></span>
                        <span>
                            { sampleText.title }
                        </span>
                    </button>
                </p>
            );
        });
    
        return (
            <div className="samplescontrol-wrapper">
                <div className="samplescontrol-samples">
                    <h2 className='heading-4'>Select a Sample Document</h2>
                    { sampleDocuments }
                </div>
    
                <RecentList
                    list={this.state.list}
                    clearList={this.clearList}
                    update = {this.process}
                    deleteItem={this.removeFromLocal}
                />
            </div>
        );
    }
}

SamplesControl.propTypes = {
    onChange: PropTypes.func
};

export default SamplesControl;
